import type { storefrontContract } from '@montugroup/contracts-warehousing-api';
import type { ClientInferRequest } from '@ts-rest/core';
import type { UseInfiniteQueryOptions } from '@ts-rest/react-query';
import { useWholesaleApiContext } from '../useWholesaleApiContext';

export const useConsignmentList = (
  {
    page,
    size,
    filter,
    sort,
  }: {
    page: number;
    size: number;
    filter?: ClientInferRequest<typeof storefrontContract.listConsignments>['query']['filter'];
    sort?: string;
  },
  options?: UseInfiniteQueryOptions<typeof storefrontContract.listConsignments>,
) => {
  const { clientApi, bearerToken } = useWholesaleApiContext();

  return clientApi().listConsignments.useInfiniteQuery(
    ['listConsignments', page, size, filter, sort],
    ({ pageParam }) => {
      return {
        headers: { authorization: bearerToken },
        query: {
          page: pageParam?.page ?? page,
          size: pageParam?.size ?? size,
          filter,
          sort,
        },
      };
    },
    {
      getNextPageParam: (lastPage, allPages) => {
        return lastPage.status === 200
          ? lastPage.body.meta.total > allPages.length * size
            ? {
                page: allPages.length,
                size: size,
              }
            : undefined
          : undefined;
      },
      ...options,
    },
  );
};
